import React, { useState, useRef, useEffect } from 'react'
import {generatePDF} from '../../Helpers/Utilities/generatePDF'
import { QRCodeSVG } from 'qrcode.react';
import userSilhouette from "../../../assets/user-silhouette.png";


export default function MultiCard({users, team, visibleFields, custom_field_values, user_avatars, public_card, logo}) {
  const [fieldValues, setFieldValues] = useState(custom_field_values)
  const [truncateId, setTruncateId] = useState(0)
  const [truncateUserId, setTrucateUserId] = useState(0)
  const [amounts, setAmounts] = useState([])

  const focusDivRef = useRef(null);
  
    useEffect(() => {
      if (focusDivRef.current) {
        focusDivRef.current.focus();
        focusDivRef.current.scrollIntoView({ behavior: 'smooth' });
      }

      if (public_card.use_payments) {
        let prices = []
        users.map((user) => {
            prices.push({
                user_id: user.id,
                amount: public_card.donation_type == 'monthly' ? public_card.donation_amount : 50.00
            })
        })

        setAmounts(prices)
    }
    }, []);

    

    useEffect(() => {}, [amounts])
  
    function canShowPublicField(customFields, field) {
      const foundField = customFields.find(
        (f) => f.system_key === field.toString()
      );
      return foundField && foundField.visible;
    }

    const printRef = useRef(null);
    
      const handleDownload = () => {
        generatePDF(printRef.current, public_card.title);
      };
  
    const getFieldValues = (user, field) => {
      if (field.system_key == 'bio') return user.bio
      const userRecords = [];
  
      for (const innerArray of fieldValues) {
          const matchingRecords = innerArray.filter(value => value.record_id == user.id);
          userRecords.push(...matchingRecords);
      }
      if (!userRecords) return null
  
      let valueObject = userRecords.find(record => record.team_custom_field_id == field.id)
      if (valueObject) return valueObject.value 
      return null
    }
      
    const defineAge = (birthday) => {
      if (!birthday) {
        return "";
      }
      const age = Math.floor(
        (new Date() - new Date(birthday)) / (365 * 24 * 60 * 60 * 1000)
      );
      return age.toString();
    };
  
    const truncateTest = (text, id, user_id) => {
      if (text.length > 200) {
          if (truncateId != id || truncateUserId != user_id) return text.substring(0, 200) + '...'
          if (truncateId == id && truncateUserId == user_id) return text
      } else {
          return text
      }
    }
  
    const visitSponsorPage = (id) => {
        let amount = getRecordAmount(id)
      let sponsorUrl = `/public/cards/sponsor/${id}/${public_card.unique_id}/new?type=signup`;
      if (public_card.use_payments) {
          sponsorUrl += `&amount=${amount}`;
      }
  
      if (public_card.use_payments && (!amount || amount < 1)) {
          Alert.show('notice', 'Donation amount must be more than $1')
          return
      }
  
      window.open(sponsorUrl, '_blank');
    }

    const getAvatar = (id) => {
        if (user_avatars && user_avatars.length > 0) {
            let avatar = user_avatars.find(avatar => avatar.user_id === id);
            return avatar ? avatar.url : null;
        }
        return null;
    }

    const changeAmounts = (amount, id) => {
        const updatedAmounts = amounts.map((a) => {
            if (a.user_id === id) {
                return { ...a, amount: parseInt(amount) };
            }
            return a;
        });

        setAmounts(updatedAmounts)
    };

    const getRecordAmount = (id) => {
        const record = amounts.find(a => a.user_id === id);
        return record ? record.amount : null;
    };

   const getAmounts = (amount = null) => {
        const rawAmount = parseFloat(amount);
        if (!rawAmount || rawAmount <= 0) return '0.00';

        if (public_card.payment_method !== 'stripe') {
            return rawAmount.toFixed(2);
        }

        if (public_card.pass_processing_fee) {
            // Correct formula to ensure you net the original amount
            let raw_amount = rawAmount
            let fee = (((raw_amount + 0.30) / (1 - 0.034)) - raw_amount).toFixed(2)
            let total = (parseFloat(raw_amount) + parseFloat(fee)).toFixed(2)
            return parseFloat(total).toFixed(2);
        }

        return rawAmount.toFixed(2);
    };

    const getProcessingFee = (amount = null) => {
        const rawAmount = parseFloat(amount);
        if (!rawAmount || rawAmount <= 0) return '0.00';
        
        // We calculate what the total would be, then subtract the original amount
        let total = (rawAmount + 0.30) / (1 - 0.034);
        let fee = total - rawAmount;
        
        return fee.toFixed(2);
    };


    return (
        <div>
                <button onClick={() => handleDownload()} className='btn btn-primary btn-sm' style={{cursor: 'pointer'}}>
                    Download PDF
                </button>
                
            <div ref={printRef}>
                <div className='text-center' style={{margin: '0px'}}>
                    {logo && (
                        <div className="logo logo-sm" style={{maxWidth: 'unset !important'}}>
                            <img
                                src={logo} alt={team.name}
                                className='logo-for-public-card'
                                crossOrigin="anonymous"
                            />
                        </div>
                    )}
                    {!logo &&
                        <h1>{team.name}</h1>
                    }
                </div>

                <div>
<div className="masonry-grid">
    {users && users.map((user) => (
        <div className='masonry-item' key={user.id}>
            <div 
                className='card'
                style={{
                    width: '100%',
                    /* Removed max/min width so it fluidly fills the column */
                    height: 'fit-content', /* Crucial for masonry so cards stack tightly */
                }}
            >
                <div className="p-2">
                    <img
                        src={getAvatar(user.id) ? getAvatar(user.id) : userSilhouette}
                        className="card-img-top rounded"
                        alt="Avatar"
                    />
                </div>

                {/* Consolidated duplicate card-body divs */}
                <div className='card-body pt-2'>
                    <h4 className="mb-1 fw-bold">
                        {canShowPublicField(visibleFields, "first_name") &&
                        `${user.first_name} `}

                        {canShowPublicField(visibleFields, "last_name") &&
                        `${user.last_name}`}
                    </h4>

                    {canShowPublicField(visibleFields, "birthday") &&
                        user.birthday != null &&
                        <p className='text-muted small mb-2'>
                            {user.birthday + " (" +
                                defineAge(user.birthday) + " years old)"
                            }
                        </p>
                    }

                    {visibleFields.map((field) => {
                        if (
                            field.system_key === "first_name" ||
                            field.system_key === "last_name" ||
                            field.system_key === "birthday"
                        ) {
                            return null;
                        }

                        const value = getFieldValues(user, field);
                        return (
                            <div key={field.id}>
                            {value != "" && (
                                <div className="mb-2 sponsorship-template-fields">
                                    <p className="text-bold small mb-2">
                                    {field.name}
                                    </p>
                                    {value && field.value_type == 'link' &&
                                        <a href={value} target='_blank' rel="noreferrer">{ field.anchor_text ? field.anchor_text : field.name }</a>
                                    }
                                    {value && field.value_type !== 'link' &&
                                        <p className="text-muted small">
                                            {truncateTest(value, field.id, user.id)}
                                            {truncateTest(value, field.id, user.id).length <= 203 && 
                                                value.length > 200 &&
                                                <span 
                                                    className='text-blue' 
                                                    onClick={() => { setTruncateId(field.id); setTrucateUserId(user.id)} }
                                                    style={{cursor: 'pointer', color: 'blue'}}
                                                > 
                                                    {' show more' }
                                                </span>
                                            }
                                            {truncateTest(value, field.id, user.id).length > 203 &&
                                                <span 
                                                    className='text-blue' 
                                                    onClick={() => {setTruncateId(0); setTrucateUserId(0)}} 
                                                    style={{cursor: 'pointer', color: 'blue'}}
                                                > 
                                                    {' show less'}
                                                </span>
                                            }
                                        </p>
                                    } 
                                    {!value && field.system_key == 'bio' &&
                                        <p className="text-muted small">
                                            No data available.
                                        </p>
                                    }
                                </div>
                            )}
                            </div>
                        )
                    })}

                    {public_card.generate_qr_code &&
                        <div className="qr-container">
                            <p className="text-bold small mb-2">
                                Confirmation QR Code
                            </p>
                            <QRCodeSVG 
                                value={`${window.location.origin}/public/cards/sponsor/show/confirmation/${public_card.unique_id}/${user.id}`} 
                                size={128}
                                level={"H"} // High error correction
                            />
                        </div>
                    }

                    {!public_card.view_only && 
                        <>
                            {public_card.use_payments && public_card.donation_type == 'monthly' &&
                                <div className='mt-3'>
                                    <h5><b>Total</b>: {`$${getAmounts(public_card.donation_amount)} / Month`}</h5>
                                </div>
                            }
                                
                            {public_card.use_payments && public_card.donation_type == 'one_time' &&
                                <div className='mt-3'>
                                    <div>
                                        <div className="form-group" style={{padding: '0px'}}>
                                            <label htmlFor={`donation_amount_${user.id}`}>Amount (USD)</label>
                                            <input
                                                className="form-control"
                                                placeholder="100.00"
                                                type="number"
                                                name={`donation_amount_${user.id}`}
                                                id={`donation_amount_${user.id}`}
                                                value={getRecordAmount(user.id)}
                                                step={10}
                                                min={2.00}
                                                onChange={(e) => {
                                                    changeAmounts(e.target.value, user.id)
                                                }}
                                            />
                                        </div>
                                    </div> 

                                    {public_card.use_payments && public_card.pass_processing_fee && public_card.payment_method == 'stripe' &&
                                        <div className='mt-3'>
                                            <h5><b>Processing Fee</b>: {`$${getProcessingFee(getRecordAmount(user.id))}`}</h5>
                                        </div>
                                    }

                                    {public_card.use_payments &&
                                        <div className='mt-3'>
                                            <h5><b>Total</b>: {`$${getAmounts(getRecordAmount(user.id))}`}</h5>
                                        </div>
                                    }
                                </div>
                            }

                            <a className="btn btn-primary mt-3 text-center w-100"
                                href='#'
                                onClick={() => visitSponsorPage(user.id)}
                                ref={focusDivRef}
                                tabIndex={-1}
                            >
                                Sponsor
                            </a>
                        </>
                    }
                </div>
            </div>
        </div>
    ))}
</div>
        </div>
    </div>
    </div>
    )
}
